export function bindOtpDigitDataIds(root: HTMLElement, dataIdPrefix: string) {
  root.querySelectorAll<HTMLElement>('.otp-input__cell').forEach((cell, index) => {
    cell.setAttribute('data-id', `${dataIdPrefix}${index + 1}`);
  });
}
